<ng-container *ngIf="data$ | async as data">
  <div
    *ngIf="data.shouldShow"
    class="timer-container"
    [ngClass]="data.contextualClass"
  >
    <span>
      {{ data.currentDuration | secondsToTime }}
    </span>
    <span>/</span>
    <span>
      {{ data.targetDuration | secondsToTime }}
    </span>
  </div>
</ng-container>
